import { CumulativeBooster } from "../cumulative_booster.js";
import { CumulativeBoosterID } from "../cumulative_booster_id.js";
import type { FireworksBoosterContext, FireworksTarget } from "./fireworks_booster.js";

/** Temporary implementation shared by Dynamite and Rocket. */
export class LevelStartFireworksBooster extends CumulativeBooster<FireworksBoosterContext>
{
  private static readonly DEFAULT_FIREWORK_COUNT = 3;
  private static readonly DEFAULT_SHOT_INTERVAL_SECONDS = 0.15;
  private readonly firework_count: number;
  private readonly shot_interval_seconds: number;
  private targets: FireworksTarget[] = [];
  private next_target_index = 0;
  private time_to_next_firework = 0;

  public constructor(
    id: CumulativeBoosterID.Dynamite | CumulativeBoosterID.Rocket,
    firework_count = LevelStartFireworksBooster.DEFAULT_FIREWORK_COUNT,
    shot_interval_seconds = LevelStartFireworksBooster.DEFAULT_SHOT_INTERVAL_SECONDS
  )
  {
    super( id );
    this.firework_count = Math.max( 1, Math.floor( firework_count ) );
    this.shot_interval_seconds = Math.max( 0, shot_interval_seconds );
  }

  protected override onActivate( context: FireworksBoosterContext ): void
  {
    this.targets = context.getRandomFireworksTargets( this.firework_count );
    this.next_target_index = 0;
    this.time_to_next_firework = 0;
    if ( this.targets.length === 0 )
      this.complete();
    else
      this.fireNext( context );
  }

  protected override onUpdate( context: FireworksBoosterContext, dt: number ): void
  {
    this.time_to_next_firework -= dt;
    while ( this.next_target_index < this.targets.length && this.time_to_next_firework <= 0 )
      this.fireNext( context );
    if ( this.next_target_index >= this.targets.length )
      this.complete();
  }

  protected override onReset(): void
  {
    this.targets = [];
    this.next_target_index = 0;
    this.time_to_next_firework = 0;
  }

  private fireNext( context: FireworksBoosterContext ): void
  {
    context.fireFireworkAt( this.targets[this.next_target_index], this.id === CumulativeBoosterID.Rocket );
    this.next_target_index++;
    this.time_to_next_firework += this.shot_interval_seconds;
  }
}
